var metaInfo={
    title:"食品行业_Movibot服务行业",
    keywords:"工业机器人_食品行业工业机器人",
    description:"工业机器人为食品行业提供食品装箱、智能厨房、包装等服务，助力食品产业升级，提高产能",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/5.js